document.addEventListener('scroll', function() {
  var stickyElement = document.querySelector('.product__mobile-sticky');
  var collapsibleSection = document.getElementById('ProductCollapsibles');

  // Verificar si la resolución es menor a 749px para que se aplique sólo en mobile
  if (window.innerWidth >= 749) {
    stickyElement.style.display = 'none'; 
    return;
  } 

  // Obtener la posición del contenedor ProductCollapsibles
  var rect = collapsibleSection.getBoundingClientRect();

  // Verificar si el contenedor está visible en la ventana
  if (rect.top < window.innerHeight && rect.bottom > 0) {
    stickyElement.style.display = 'block';  // Mostrar el botón
    stickyElement.style.position = 'fixed';
    stickyElement.style.bottom = '0';
  } else {
    stickyElement.style.display = 'none';  // Ocultar el botón
  }
});

// Verificar el tamaño de la pantalla al cargar la página y al redimensionar
window.addEventListener('resize', function() {
  var stickyElement = document.querySelector('.product__mobile-sticky');
  if (window.innerWidth >= 749) {
    stickyElement.style.display = 'none';
  }
});
